import api from "./axios"

/* ===================== KYC DOCUMENT SUBMISSION ===================== */
export const documentsApi = {
    uploadAadhaar: async (formData) => {
        // formData is already built in Kyc3.jsx handleSubmit
        // just send it directly
        const res = await api.post(
            "/api/kyc/upload",
            formData,  // ✅ sending FormData directly
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return res.data;
    },
};
